// extracted by mini-css-extract-plugin
module.exports = {"root":"Pagination_root__dQzrg","dots":"Pagination_dots__rtvMm","item":"Pagination_item__aAT5a","active":"Pagination_active__pC48G"};